import styles from "./content-page-body-description.less";

type ContentPageBodyDescriptionProps = {
    descriptionText: string;
};

export const ContentPageBodyDescription = (props: ContentPageBodyDescriptionProps) => {
    const {
        descriptionText
    } = props;

    return (
        <span className={styles.contentPageBodyDescription}>{descriptionText}</span>
    );
};